/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Tip_Discord_Official_TInputs */



/**
* | output |
* | --- |
* | "The bot on the official server" |
*
* @param {Tournament_Wiz_Tip_Discord_Official_TInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_tip_discord_official_t = /** @type {((inputs?: Tournament_Wiz_Tip_Discord_Official_TInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Tip_Discord_Official_TInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le bot sur le serveur officiel")
	if (locale === "es") return /** @type {LocalizedString} */ ("El bot en el servidor oficial")
	if (locale === "pt") return /** @type {LocalizedString} */ ("O bot no servidor oficial")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il bot sul server ufficiale")
	return /** @type {LocalizedString} */ ("The bot on the official server")
});